import * as Sentry from '@sentry/gatsby'
import { Integrations } from '@sentry/tracing'
import { useHasConsent } from '@websrc/App/Hooks/useHasConsent/useHasConsent'
import { useEffect } from 'react'

import { isUnderTest } from '../Helpers/isUnderTest'

export const useSentry = () => {
  const hasConsent = useHasConsent(['analytics'])

  useEffect(() => {
    // environment is definitely set from gatsby-node
    const environment = process.env.CONTENTSTACK_ENVIRONMENT || ''
    const enabled = process.env.SENTRY_ENABLED === '1'
    const tracesSampleRate = process.env.SENTRY_TRACE_SAMPLES || 0.01
    if (isUnderTest()) return
    if (enabled) {
      const baseConfig: Sentry.BrowserOptions = {
        dsn: process.env.SENTRY_DSN,
        environment,
        release: process.env.GIT_SHA,
        enabled: enabled ? process.env.BOB_BUILD_TYPE !== 'preview' : false,
        // based on fetch being possible to cancel by the user
        // https://stackoverflow.com/a/60860369/3708153
        ignoreErrors: [
          'TypeError: Failed to fetch',
          'TypeError: NetworkError when attempting to fetch resource.',
          'TypeError: Cancelled',
        ],
      }

      if (hasConsent) {
        Sentry.init({
          tracesSampleRate: Number(tracesSampleRate),
          autoSessionTracking: true,
          integrations: [new Integrations.BrowserTracing()],
          ...baseConfig,
        })
      } else {
        Sentry.init({
          ...baseConfig,
        })
      }

      Sentry.configureScope((scope) => scope.setUser(null))
    }
  }, [hasConsent])
}
